import styles from "./Summary.module.scss";

const Summary = ({}) => {
  const closeText = "折りたたむ";
  const openText = "開く";

  const clickSummary = (e) => {
    if (e.currentTarget.textContent == closeText) {
      e.currentTarget.textContent = openText;
    } else {
      e.currentTarget.textContent = closeText;
    }
  };

  return (
    <summary className={styles.summary} onClick={(e) => clickSummary(e)}>
      {closeText}
    </summary>
  );
};
export default Summary;
